import React from 'react'
import { useStyles } from './styles'

/*
Copyright 2022-07-08 por Jorge Parrado Ecomsur Holding S.A ©
Detalle: Crea logica y acciones para buscar ot desconociendo ID
*/

interface ButtonFilterProps {
  isSelected: boolean
  text: string
  onClick: () => void
}

export const ButtonFilter = ({
  isSelected,
  onClick,
  text
}: ButtonFilterProps) => {
  const classes = useStyles()
  return (
    <div
      onClick={onClick}
      className={`${classes.ButtonContainer} ${
        isSelected ? classes.BtnSelected : classes.BtnDefault
      }`}
    >
      <strong>{text}</strong>
    </div>
  )
}
